import { render } from "./BlogCategoriesLifestyle.vue?vue&type=template&id=6c5bd2c6&scoped=true"
import script from "./BlogCategoriesLifestyle.vue?vue&type=script&lang=js"
export * from "./BlogCategoriesLifestyle.vue?vue&type=script&lang=js"

import "./BlogCategoriesLifestyle.vue?vue&type=style&index=0&id=6c5bd2c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c5bd2c6"

export default script